<template>
    <form action="">
        <app-form-text-input
            label="Nombre del Área"
            v-model="area.name"
            :has-error="$v.area.name.$error"
            error-message="Debe escribir el nombre del área"
            :required="true"
        />
        <app-form-select-input
            label="Sede (Opcional)"
            v-model="area.venueId"
            :options="venueOptions"
            :is-object="false"
        />
        <app-form-textarea-input
            label="Descripción"
            v-model="area.description"
        />
    </form>
</template>
<script>
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue';
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue';
import FormTextareaInput from '../../UI/Controls/Forms/FormTextareaInput.vue';
import clientAreasRepository from '../../../repositories/client-areas.repository';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appFormTextareaInput: FormTextareaInput
    },
    props: {
        selectedArea: {
            type: Object,
            default: null
        },
        venues: {
            type: Array,
            default: () => []
        },
        onSave: {
            type: Function,
            default: () => false
        },
        id: {
            type: String,
            default: () => `client-area-form-${parseInt(Math.random() * 10000000)}`
        }
    },
    data() {
        return {
            area: {
                id: '',
                name: '',
                venueId: '',
                description: ''
            }
        };
    },
    watch: {
        selectedArea(val) {
            if (val) {
                this.area = {
                    id: val.id,
                    name: val.name,
                    venueId: val.venue_id || '',
                    description: val.description || ''
                };
            }
        }
    },
    validations: {
        area: {
            name: { required }
        }
    },
    computed: {
        venueOptions() {
            return [
                ...this.venues
            ];
        }
    },
    methods: {
        clear() {
            this.area = {
                id: '',
                name: '',
                venueId: '',
                description: ''
            };
            this.$nextTick(() => {
                if (this.$v) {
                    this.$v.$reset();
                }
            });
        },
        async saveArea() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Debe completar los campos obligatorios');
                return;
            }

            try {
                const payload = {
                    name: this.area.name,
                    venueId: this.area.venueId || null,
                    description: this.area.description || null
                };

                let response;
                if (this.area.id) {
                    response = await clientAreasRepository.update(this.area.id, payload);
                } else {
                    response = await clientAreasRepository.save(payload);
                }

                const { data } = response;
                if (data.status) {
                    this.clear();
                    toastr.success(data.msg || 'Información guardada satisfactoriamente');
                    this.onSave();
                } else {
                    toastr.error(data.msg || 'Error al guardar el área');
                }
            } catch (error) {
                toastr.error('Ocurrió un error al guardar el área');
            }
        }
    },
    created() {
        this.$bus.$on('client-area-form.save', this.saveArea);
        this.$bus.$on(`${this.id}.clear`, this.clear);
    },
    beforeDestroy() {
        this.$bus.$off('client-area-form.save');
        this.$bus.$off(`${this.id}.clear`);
    }
};
</script>

